import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            companyId: '',
            filter: '',
            fromDate: '',
            toDate: '',
            companyName: '',
            isDateError : null,
            openAddOrder: false,
            companies: [],
            dispatchers: [],
            dispatchersCount: [],
            types: [],
        }
    },
    computed: {
        filteredUsers() {
            return this.companies.filter(item => {
                return this.checkNull(item.name).toLowerCase().indexOf(this.filter.toLowerCase()) > -1;

            })
        }
    },
    methods: {
        getReport: getReport,
        round: round,
        getDispatchers: getDispatchers,
        changedDateFrom: changedDateFrom,
        changedDateTo: changedDateTo,
        keymonitor: keymonitor,
        checkNull: checkNull,
        openAddUserModal: openAddUserModal,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            if (a.count > b.count)
                return -1;
            if (a.count < b.count)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddVehicle', () => {
            _self.openAddOrder = false;
        });
        this.$topnavbar.$on('successAddVehicle', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno dodato vozilo', 'success')
            _self.getVehicles();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.getDispatchers();
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')

    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function getDispatchers(){
    let _self = this;
    AdminApiService.getDispatchers()
        .then((response) => {
            _self.dispatchers = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function openAddUserModal() {
    this.openAddOrder = true;
}

function changedDateFrom() {

}


function changedDateTo() {

}

function getReport() {
    var _self = this;
    var calendarTimestampFrom = Date.parse(_self.fromDate);
    var calendarTimestampTo = Date.parse(_self.toDate);
    if(isNaN(calendarTimestampFrom)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    if(isNaN(calendarTimestampTo)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });
    _self.isDateError = null;
    var statusOrder = "&status=DELIVERED"
    var date =  "?fromTimestamp=" + calendarTimestampFrom + "&toTimestamp="+calendarTimestampTo + statusOrder;
    AdminApiService.getOrderReport(date)
        .then((response) => {
            swal('Uspešno', 'Izveštaj uspešno kreiran', 'success');
            let map = new Map();
            let rawData = response.data;
            for (let i = 0; i < rawData.length; i++) {
                if(map.get(rawData[i].company.id) == null){
                    let newModel = {
                        id: rawData[i].company.id,
                        name: rawData[i].company.name,
                        count: rawData[i].count,
                    };
                    map.set(rawData[i].company.id, newModel);
                }else{
                    let oldValue = map.get(rawData[i].company.id);
                    oldValue.count = oldValue.count + _self.checkNull(rawData[i].count);
                    map.set(rawData[i].company.id, oldValue);
                }
            }
            _self.companies = Array.from( map.values() ).sort((a, b) => _self.compareOrders(a,b));
        })
        .catch((error) => {
            console.log(error);
            swal('Greška', error.data.message, 'error')
        })

    var query = "?status=DELIVERED"
    var timestamp =  "&fromTimestamp=" + calendarTimestampFrom + "&toTimestamp="+calendarTimestampTo
    AdminApiService.getOrders(query, timestamp)
        .then((response) => {
            var dispatchersOrderMap = new Map();
            _self.dispatchersCount = [];
            response.data.forEach(o => {
                var approvedId = o.approvedBy != null ? o.approvedBy.id : null
                var id = approvedId != null && approvedId !== '' ? o.approvedBy.id : o.createdBy.id;
                if(dispatchersOrderMap.get(id) == null){
                    dispatchersOrderMap.set(id, 0)
                }
                dispatchersOrderMap.set(id, dispatchersOrderMap.get(id) + 1)
            })
            _self.dispatchers.forEach(d => {
                _self.dispatchersCount.push({ name: d.firstName + " " + d.lastName, count: dispatchersOrderMap.get(d.id) != null ? dispatchersOrderMap.get(d.id) : 0 })
            })
        })
        .catch((error) => {
            swal('Greška', error.data.message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getVehicles();
    }
}


function checkNull(data) {
    if(data == null) return 0;
    return data;
}


function round(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100
}





// WEBPACK FOOTER //
// ./src/components/Report/OrderReport.js